<div class="page-container unified-questionnaire-container container unified">
  <div class="unified-container">
    <app-left-nav
      [currentApp]="currentApp"
      [stepInput]="currentStep"
      [iwValidateTrack]="iwValidate"
      [iwProg]="progSelectedIW?.selectionType"
      [selectedIWProg]="progSelectedIW?.program"
      [liValidateTrack]="liValidate"
      [modules]="modules"
      (appPage)="handleAppPage($event)"
    />

    <div #focusCatcher class="content" tabindex="0">
      <div class="unified-header mb-2">
        @if (!unfFlowSvc.getloading()) {
          <h1>
            {{ currentAppDisplay() }}
            @if (currentStepDisplay()) {
              - {{ currentStepDisplay() }}
            }
            @if (currentApp === 'summary' && summaryCaseNumber) {
              : <span class="case-number">#{{ summaryCaseNumber }}</span>
            }
          </h1>
        }
        @if (showImportCaseButton() && !(hideForm() || !profileData)) {
          <button
            type="button"
            class="import-case-button"
            matButton="elevated"
            color="accent"
            matTooltip="Copy information from a previously created case"
            [style.margin-left]="
              rights.includes('AIChatbotOnQuestionnaire') ? 'auto' : null
            "
            (click)="copyCase()"
          >
            <mat-icon>system_update_alt</mat-icon> Import Case Info
          </button>
        }

        @if (
          rights.includes('AIChatbotOnQuestionnaire') &&
          !hideForm() &&
          this.currentApp === 'rb'
        ) {
          <button
            type="button"
            class="ai-case-button"
            matButton="elevated"
            color="accent"
            matTooltip="Use AI Assistant to fill out your case information"
            (click)="router.navigate([`rb-chatbot/${profile}`])"
          >
            <mat-icon>auto_awesome</mat-icon> Use AI Assistant
          </button>
        }
      </div>
      @if (checkStatus()) {
        <app-formly
          #formlyComponent
          class="mx-0"
          [hidden]="hideForm() || !profileData"
          [context]="tabContext"
          [data]="profileData"
          [externalSubmit]="formSubmitted"
          (newProfile)="handleNewProfile($event)"
          (formChange)="handleModelChange($event)"
        />
      }
      <!--  -->
      <!-- PP Pages -->
      <!--  -->
      @if (currentStep === 'results' && currentApp === 'pp') {
        <app-pp-results
          [hidden]="unfFlowSvc.getloading()"
          [profile]="this.profile"
          (prodsSelected)="handlePPProds($event)"
        />
      }
      <!--  -->
      <!-- AW Pages -->
      <!--  -->
      @if (currentApp === 'aw') {
        @if (currentStep === 'compare-results') {
          <app-aw-comparison />
        }
        @if (currentStep === 'results') {
          <app-annuities-result
            [hidden]="unfFlowSvc.getloading() && !downloadingFactsheet"
            [hasSummaryModule]="modStatusSvc.showCaseSummary()"
            (downloadFactsheet)="downloadFactsheet($event)"
          />
        }
      }
      <!--  -->
      <!-- IW Pages -->
      <!--  -->
      @if (currentApp === 'iw') {
        @if (currentStep === 'program-selection') {
          <app-program-selection
            [hidden]="unfFlowSvc.getloading()"
            (navigate)="handleTabChange($event)"
            (progSelected)="handleIWProg($event)"
          />
        }
        @if (currentStep === 'investment-model') {
          <app-model-selection
            [hidden]="unfFlowSvc.getloading()"
            (navigate)="handleTabChange($event)"
            (updateFormModel)="updateModel($event)"
          />
        }
        @if (currentStep === 'fund-allocations' || currentStep === 'advisory') {
          <app-fund-allocations
            [hidden]="unfFlowSvc.getloading()"
            (navigate)="handleTabChange($event)"
            (updateFormModel)="updateModel($event)"
          />
        }
        @if (currentStep === 'validate') {
          <app-iw-result
            [hidden]="unfFlowSvc.getloading()"
            [hasSummaryModule]="modStatusSvc.showCaseSummary()"
          />
        }
      }
      <!--  -->
      <!-- LI Pages -->
      <!--  -->
      @if (currentApp === 'li') {
        @if (currentStep === 'results' || currentStep === 'needs') {
          <app-results
            [hidden]="unfFlowSvc.getloading()"
            (navigate)="handleTabChange($event)"
          />
        }
        @if (currentStep === 'compare') {
          <app-scenarios
            [hidden]="unfFlowSvc.getloading()"
            (navigate)="handleTabChange($event)"
          />
        }
        @if (currentStep === 'validate') {
          <app-validate
            [hidden]="unfFlowSvc.getloading()"
            [hasSummaryModule]="modStatusSvc.showCaseSummary()"
            (navigate)="handleTabChange($event)"
          />
        }
        @if (currentStep === 'products') {
          <app-product-result
            [hidden]="unfFlowSvc.getloading()"
            (selectedProdLW)="handleLWProd($event)"
          />
        }
      }
      <!--  -->
      <!-- Summary Page -->
      <!--  -->
      @if (currentApp === 'summary') {
        <app-unified-summary-page
          (navigateTo)="handleSummaryNavigate($event)"
          (summaryClient)="setSummaryClient($event)"
          (aiSummaryChecked)="aiSummaryChecked($event)"
        />
      }
      @if (currentApp !== 'summary') {
        <div class="main-nav-container sticky-nav">
          <app-main-nav
            [currentStep]="currentStep"
            [currentApp]="currentApp"
            [navDisabled]="navDisabled"
            [profileData]="profileData"
            [loading]="unfFlowSvc.getloading()"
            (changeTab)="handleTabChange($event)"
          />
        </div>
      }
    </div>
  </div>
</div>
<ngx-loading
  [show]="unfFlowSvc.getloading()"
  [config]="{ primaryColour: '#ffffff' }"
/>
